import Invitee from './Invitee';

export default Invitee;
